<div class="container">
    <input type="radio" [checked]="checked" [name]="name" (click)="selectChoice(choiceValue)" [id]="id">
    <span class="checkmark"></span>
</div>